import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("CCPT")
    .schemaType("ccpt")
    .child(S.documentTypeList("ccpt"));
